/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions } from '@tanstack/react-query';

import type {
  BboPouchManagementBadRequestResponse,
  BboPouchManagementFailureResponseResponse,
  BboPouchManagementForbiddenResponse,
  PouchStatusRequestBodyBody,
  SuccessResponse,
  UnauthorizedResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * This API will be called before Pouch Preparation Completion any activity that user got invoke with Eg. "suspended" ,"cancelled" ,"suspend-timedout", "suspend-cancelled", "suspend-system-failure"
 * @summary Update Pouch status
 */
export const updatePouchStatus = (pouchStatusRequestBodyBody: PouchStatusRequestBodyBody) => {
  return customInstance<SuccessResponse>({
    url: `/bm-pouch-management/v1/pouch/status`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: pouchStatusRequestBodyBody,
  });
};

export const getUpdatePouchStatusMutationOptions = <
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePouchStatus>>,
    TError,
    { data: PouchStatusRequestBodyBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePouchStatus>>,
  TError,
  { data: PouchStatusRequestBodyBody },
  TContext
> => {
  const { mutation: mutationOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePouchStatus>>,
    { data: PouchStatusRequestBodyBody }
  > = (props) => {
    const { data } = props ?? {};

    return updatePouchStatus(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePouchStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePouchStatus>>
>;
export type UpdatePouchStatusMutationBody = PouchStatusRequestBodyBody;
export type UpdatePouchStatusMutationError = ErrorType<
  | BboPouchManagementBadRequestResponse
  | UnauthorizedResponse
  | BboPouchManagementForbiddenResponse
  | BboPouchManagementFailureResponseResponse
>;

/**
 * @summary Update Pouch status
 */
export const useUpdatePouchStatus = <
  TError = ErrorType<
    | BboPouchManagementBadRequestResponse
    | UnauthorizedResponse
    | BboPouchManagementForbiddenResponse
    | BboPouchManagementFailureResponseResponse
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePouchStatus>>,
    TError,
    { data: PouchStatusRequestBodyBody },
    TContext
  >;
}) => {
  const mutationOptions = getUpdatePouchStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
